module.exports = __webpack_public_path__ + "assets/img/evalItem04.9d8f7e49.png";